import React from 'react';
import { Chart } from 'react-google-charts';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const SalesByTopCuisines = (props) => {
  const { classes } = props;
  return (<div className={'w-100'}>
    { /* <Card className={classes.root}>
    <CardHeader subheader="Sales By Top Cuisines" classes={{ subheader: classes.header }} />
<CardContent> */ }
    <Chart
      height={'400px'}
      width={'100%'}
      //height={'300px'}
      //width={'500px'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      data={[
        ['Task', 'Hours per Day'],
        ['Chinese', 37],
        ['Italian', 17],
        ['Mexican', 15],
        ['Punjabi', 15],
        ['Milk Shakes', 16],
      ]}
      options={{
        title: 'Sales By Top Cuisines',
        colors: ['#f58634', '#ffa600', '#6baf30', '#548100', '#969600'],
        legend: { position: 'right' },
      }}
      rootProps={{ 'data-testid': '1' }}
    />
    { /* </CardContent>
    </Card> */ }
  </div>)
};

export default SalesByTopCuisines;
